import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ArtisanConnectMarketplace from './pages/artisan-connect-marketplace';
import Contact from './pages/contact';
import InteractiveMandalaAI from './pages/interactive-mandala-ai';
import VirtualTourExperience from './pages/virtual-tour-experience';
import AboutUs from './pages/about-us';
import Homepage from './pages/homepage';
import Events from './pages/cultural-events-festivals/Events';
import NarratedWalkthroughs from "./pages/NarratedWalkthroughs";
import InteractiveMonasteryMap from "./pages/InteractiveMonasteryMap";
import Register from './pages/auth/Register';
import Login from './pages/auth/Login';
import DigitalArchivesPage from "./pages/digital-archieve";
import SmartAudioGuidePage from "./pages/smart-audio-guide";
import VirtualTour360View from "pages/virtual-tour-experience/components/Virtual_tour_360";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<Homepage />} />
        <Route path="/artisan-connect-marketplace" element={<ArtisanConnectMarketplace />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/interactive-mandala-ai" element={<InteractiveMandalaAI />} />
        <Route path="/virtual-tour-experience" element={<VirtualTourExperience />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/events" element={<Events />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/digital-archives" element={<DigitalArchivesPage />} />
        <Route path="/smart-audio-guide" element={<SmartAudioGuidePage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/NarratedWalkthroughs" element={<NarratedWalkthroughs />} />
        <Route path="/InteractiveMonasteryMap" element={<InteractiveMonasteryMap />} />
        <Route path="/vr-360" element={<VirtualTour360View />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
